import { cn } from '@Utils';

interface LabelToggleProps {
  label: string;
  className?: string;
}

const LabelToggle = ({ label, className }: LabelToggleProps) => {
  return <span className={cn('text-[15px] font-medium', className)}>{label}</span>;
};

export default LabelToggle;
